import { render, staticRenderFns } from "./CustomerOrderDialog.vue?vue&type=template&id=53bf8552&"
import script from "./CustomerOrderDialog.vue?vue&type=script&lang=js&"
export * from "./CustomerOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports